import React from "react"
import Circle from "@mui/icons-material/Circle"

const LegendItem = ({ Icon = Circle, iconColor, label, iconSize = 16 }) => {
  return (
    <li className="d-flex align-items-center mb-1">
      <Icon className="me-2" style={{ fontSize: `${iconSize}px`, color: iconColor }} />
      <span className="ml-2 flex-grow-1 text-nowrap">{label}</span>
    </li>
  )
}

export default LegendItem
